import en from './en.json';
import de from './de.json';
import fr from './fr.json';
import fi from './fi.json';
import es from './es.json';
import sv from './sv.json';
import nl from './nl.json';
import pt from './pt.json';

export default {
  en,
  de,
  fr,
  fi,
  es,
  sv,
  nl,
  pt,
};
